import React, { FunctionComponent, useState } from 'react';

interface ApplyNowButtonProps {
  cta?: string;
  url: string;
}

interface IconProps {
  fill?: string;
}

const Icon: FunctionComponent<IconProps> = ({ fill }) => (
  <svg
    className="flex-none"
    width="25.701"
    height="25.595"
    viewBox="0 0 25.701 25.595"
  >
    <path
      id="Path_4"
      data-name="Path 4"
      d="M57.7,50.683a.511.511,0,0,1,.256.186.53.53,0,0,1-.113.715.512.512,0,0,1-.3.1c-3.2,0-6.4-.048-9.6,0a.827.827,0,0,0-.785.795c-.017,5.437-.084,10.874,0,16.311a.82.82,0,0,0,.795.785c5.437.019,10.874.082,16.31,0a.828.828,0,0,0,.785-.795V59.188l.025-.158a.511.511,0,0,1,.186-.256.533.533,0,0,1,.715.113.511.511,0,0,1,.1.3c0,3.2.01,6.4,0,9.6a1.869,1.869,0,0,1-1.811,1.811q-8.157.029-16.314,0a1.873,1.873,0,0,1-1.811-1.812q-.025-8.157,0-16.313a1.874,1.874,0,0,1,1.822-1.812h9.585l.158.025ZM66.96,46a1.308,1.308,0,0,1,.876.363c.847.837,1.683,1.683,2.525,2.525a1.311,1.311,0,0,1,0,1.8L57.507,63.547a.679.679,0,0,1-.193.121c-1.344.468-2.686.943-4.033,1.4a1.318,1.318,0,0,1-1.6-.735,1.293,1.293,0,0,1-.021-.894l1.4-4.023a.68.68,0,0,1,.121-.193L66.042,46.373A1.3,1.3,0,0,1,66.96,46Zm-2.4,3.3-10.57,10.57-1.362,3.91a.265.265,0,0,0,.325.324l3.91-1.362c3.523-3.523,7.1-6.992,10.6-10.542Zm3.618,2.171q.733-.749,1.46-1.5a.263.263,0,0,0,0-.353c-.835-.845-1.664-1.7-2.52-2.519a.254.254,0,0,0-.356.006l-1.476,1.476Z"
      transform="translate(-45.635 -45.5)"
      fill={fill}
      stroke={fill}
      strokeWidth="1"
      fillRule="evenodd"
    />
  </svg>
);

const ApplyNowButton: FunctionComponent<ApplyNowButtonProps> = ({
  cta = 'Apply Now',
  url,
}) => {
  const [fill, setFill] = useState('#fff');

  const onHover = () => {
    setFill(fill === '#fff' ? '#5FBEC2' : '#fff');
  };

  return (
    <a
      className={`
        apply-now hidden absolute transform -rotate-90 text-center
        bg-pink px-24 py-3 pb-4 text-white rounded-t-2xl
        lg:block z-10
      `}
      href={url}
      onMouseEnter={onHover}
      onMouseLeave={onHover}
    >
      <span className="flex flex-row flex-nowrap items-center content-start space-x-4">
        <Icon fill={fill} />
        <span className="flex-1 uppercase text-sm font-semibold">{cta}</span>
      </span>
    </a>
  );
};

export { ApplyNowButton };
